import { combineReducers } from "redux";

// Front
import LayoutReducer from "./layouts/reducer";

// Authentication
import LoginReducer from "./auth/login/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import ChangePasswordReducer from "./auth/changepwd/reducer";
import DashboardReducer from "./dashboard/reducer";

import UserReducer from "./User/reducer";
import TicketReducer from "./Ticket/reducer"
import LeadReducer from "./Lead/reducer"
import CourseReducer from "./Course/reducer"
import TipsReducer from "./Tips/reducer"
import InsuranceReducer from "./Insurance/reducer"
import FaqReducer from "./faq/reducer"
import DoorstepDeliveryReducer from "./deliverycharge/reducer"
import GoalCategoryReducer from "./goal/reducer"
import RBACReducer from "./RBAC/reducer"

const rootReducer = combineReducers({
  Layout: LayoutReducer,
  Login: LoginReducer,
  ForgetPassword: ForgetPasswordReducer,
  ChangePassword: ChangePasswordReducer,
  Dashboard : DashboardReducer,
  User: UserReducer,
  Ticket: TicketReducer,
  Lead: LeadReducer,
  course: CourseReducer,
  tips: TipsReducer,
  insurance: InsuranceReducer,
  faq: FaqReducer,
  doorstepdelivery: DoorstepDeliveryReducer,
  goalcategory: GoalCategoryReducer,
  rbac: RBACReducer
});

export default rootReducer;
